import React from 'react';
import './css/mainviewshortbtns.css';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const MainViewShortBtns = () => {
  const { t } = useTranslation();
  
  return (
    <div className='main-view-short-btns'>
        <div className='container-fluid'>
            <div className='main-view-short-btns-content'>
                <div className='short-btn-1'>
                    <Link to='/'> {t('nav.sections')} </Link>
                </div>
                <div className='short-btn-2'>
                <Link to='/branches'> {t('nav.branches')} </Link>
                </div>
                <div className='short-btn-3'>
                <Link to='/'> {t('nav.contact')} </Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MainViewShortBtns